<template>
  <div class="app-body">
    <MakeDetailTable ref="MakeDetailTable" :price-detail="true"></MakeDetailTable>
  </div>
</template>
<script>
//加工安排菜单落地页面，显示加工单明细及对应操作
import MakeDetailTable from '@/components/MakeDetailTable.vue'

export default {
  name: 'make-detail-manager',
  components: {
    MakeDetailTable
  },
  activated () {
    this.$nextTick(() => {
      this.$refs.MakeDetailTable.reload()
    })
  }
}
</script>
